import { render, staticRenderFns } from "./OverlayContainer.vue?vue&type=template&id=743bc4d5&scoped=true&lang=pug&"
import script from "./OverlayContainer.vue?vue&type=script&lang=ts&"
export * from "./OverlayContainer.vue?vue&type=script&lang=ts&"
import style0 from "./OverlayContainer.vue?vue&type=style&index=0&id=743bc4d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743bc4d5",
  null
  
)

export default component.exports